import { render } from "./SwitchFontSize.vue?vue&type=template&id=7de18b58&scoped=true"
import script from "./SwitchFontSize.vue?vue&type=script&lang=js"
export * from "./SwitchFontSize.vue?vue&type=script&lang=js"

import "./SwitchFontSize.vue?vue&type=style&index=0&id=7de18b58&scoped=true&lang=less"
import "./SwitchFontSize.vue?vue&type=style&index=1&id=7de18b58&lang=less"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.44_vue@3.5.44_typescript@4.9.5__webpack@5.112.2_2b87b21da4aed600185acfcb8e880229/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7de18b58"]])

export default __exports__